import React from "react";
import { Photo } from "../MasterImageSearch/components/types";
import _ from "lodash";
import { Cart, Album } from "./types";
import Photos from "../MasterImageSearch/components/results/Photos";
import AlbumGallery from "../MasterImageSearch/components/results/PhotoGallery";
import MobilePhotos from "../EventGalleryMobile/Photos";
import MobileAlbumGallery from "../EventGalleryMobile/MobilePhotoGallery";
import { FindPhotosGalleryContext } from "../MasterImageSearch/components/results/PhotosContainer";
import InfiniteScroll from "react-infinite-scroll-component";
const gssNewLoader = require("./images/gss-loader.gif");

const noimgs = require("../MasterImageSearch/images/dark-no-imgs.svg");
const loader = require("./images/gss-loader.gif");

const PhotoGallery = ({
  cart,
  photos,
  loadMorePhotos,
  loadingPhotos,
  albumGrouping,
  addPhotoToCart,
  removePhotoFromCart,
  embedMode,
  hasMorePhotos,
  isAuthorizedForDirectDownloads,
  primaryColor,
  userId,
  filters,
  organizationId,
  albumFilter,
  securedOrgView,
  registerGuestUserAPI,
  setGuestUserId,
  secureAccessToken,
  disableSelectIcon,
  directDownloadEnabled
}: {
  cart: Cart;
  photos: Photo[];
  loadMorePhotos: () => void;
  loadingPhotos: boolean;
  albumGrouping: boolean;
  addPhotoToCart: (photo: Photo) => void;
  removePhotoFromCart: (photo: Photo) => void;
  embedMode: boolean;
  hasMorePhotos: boolean;
  isAuthorizedForDirectDownloads: boolean;
  primaryColor: string;
  userId?: number;
  organizationId: number;
  filters?: {
    referenceImage: string | null;
    tags: any;
  };
  albumFilter: boolean;
  securedOrgView?: boolean;
  registerGuestUserAPI: string;
  setGuestUserId: (userId: number) => void;
  secureAccessToken: string;
  disableSelectIcon?: boolean;
  directDownloadEnabled: boolean;
}) => {
  const uniqAlbums = () =>
    _.uniqWith(
      photos.map((photo: Photo) => photo.album),
      _.isEqual
    );

  const albumPhotos = (albumId: number) =>
    _.sortBy(
      _.filter(photos, (photo: Photo) => photo.album.id === albumId),
      ["timeTaken"]
    );

  const ifLastAlbum = (albumIndex: number) =>
    uniqAlbums().length === albumIndex;

  const isSelected = (photo: Photo) =>
    _.includes(cart ? cart.photos : [], photo.id);

  const structureGalleryPhotos = (photos: any) => {
    return _.uniqBy(photos, "id").map((photo: any) => {
      return {
        ...photo,
        ...(photo.timeTaken
          ? {
              tags: [
                {
                  title: "Time",
                  value: photo.timeTaken
                }
              ]
            }
          : {}),
        isSelected: isSelected(photo),
        src: "",
        disableContextMenu: true
      };
    });
  };

  const Gallery = (galleryPhotos: Photo[]) =>
    /Mobi/i.test(window.navigator.userAgent) ? (
      <FindPhotosGalleryContext.Provider
        value={{
          cart: cart,
          addPhotoToCart: addPhotoToCart,
          removePhotoFromCart: removePhotoFromCart,
          isEmbed: embedMode,
          primaryColor: primaryColor,
          directDownloadEnabled: directDownloadEnabled
        }}
      >
        <MobilePhotos
          photos={structureGalleryPhotos(galleryPhotos)}
          loadPhotos={loadMorePhotos}
          hasMore={hasMorePhotos}
          trackTelemetry={false}
          isAuthorizedForDirectDownloads={isAuthorizedForDirectDownloads}
          userId={userId}
          primaryColor={primaryColor}
          likedMedia={[]}
          handleLikeButtonClick={() => {}}
          reset={false}
          parentName={"org-gallery-lightbox"}
          securedOrgView={securedOrgView}
          registerGuestUserAPI={registerGuestUserAPI}
          setGuestUserId={setGuestUserId}
          eventClickable={true}
          disableSelectIcon={disableSelectIcon ?? true}
          secureAccessToken={secureAccessToken}
        />
      </FindPhotosGalleryContext.Provider>
    ) : (
      <div className="org-album-photos">
        <Photos
          photos={galleryPhotos}
          cart={cart}
          addPhotoToCart={photo => addPhotoToCart(photo)}
          removePhotoFromCart={photo => removePhotoFromCart(photo)}
          loadMorePhotos={loadMorePhotos}
          isEmbed={embedMode}
          hasMorePhotos={hasMorePhotos}
          isAuthorizedForDirectDownloads={isAuthorizedForDirectDownloads}
          primaryColor={primaryColor}
          userId={userId}
          parentName={"org-gallery-lightbox"}
          securedOrgView={securedOrgView}
          registerGuestUserAPI={registerGuestUserAPI}
          setGuestUserId={setGuestUserId}
          secureAccessToken={secureAccessToken}
          disableSelectIcon={disableSelectIcon ?? true}
          directDownloadEnabled={directDownloadEnabled}
        />
      </div>
    );

  const AlbumsGallery = (galleryPhotos: Photo[], albumIndex: number) =>
    /Mobi/i.test(window.navigator.userAgent) ? (
      <FindPhotosGalleryContext.Provider
        value={{
          cart: cart,
          addPhotoToCart: addPhotoToCart,
          removePhotoFromCart: removePhotoFromCart,
          isEmbed: embedMode,
          primaryColor: primaryColor
        }}
      >
        <MobileAlbumGallery
          // @ts-ignore
          photos={structureGalleryPhotos(galleryPhotos)}
          isAuthorizedForDirectDownloads={isAuthorizedForDirectDownloads}
          trackTelemetry={false}
          primaryColor={primaryColor}
          reset={false}
          userId={userId}
          likedMedia={[]}
          handleLikeButtonClick={() => {}}
          disableSelectIcon={disableSelectIcon ?? true}
          directDownloadEnabled={directDownloadEnabled}
        />
      </FindPhotosGalleryContext.Provider>
    ) : (
      <div className="org-album-photos">
        <div className="dv-album-photos" style={{ overflow: "auto" }}>
          <div className="dv-album-wrap">
            <AlbumGallery
              photos={galleryPhotos}
              cart={cart}
              addPhotoToCart={photo => addPhotoToCart(photo)}
              removePhotoFromCart={photo => removePhotoFromCart(photo)}
              loadMorePhotos={() => {
                ifLastAlbum(albumIndex) && loadMorePhotos();
              }}
              isEmbed={embedMode}
              isAuthorizedForDirectDownloads={isAuthorizedForDirectDownloads}
              primaryColor={primaryColor}
              userId={userId}
              disableSelectIcon={disableSelectIcon ?? true}
              directDownloadEnabled={directDownloadEnabled}
            />
          </div>
        </div>
      </div>
    );

  const noPhotoMatchingText = (
    filters: { tags: string | any[]; referenceImage: any } | undefined
  ) => {
    if (albumFilter) return "No album found";
    else if (filters) {
      if (filters.tags.length > 0 && filters.referenceImage)
        return "No photos match the uploaded selfie and tag, please try with a different photo or tag.";
      else if (filters.tags.length > 0)
        return "No photos match the selected tag. Try searching with a different tag.";
    } else
      return "There are no photos matching the uploaded face image. Try with a different photo.";
  };

  if (loadingPhotos) {
    return (
      <div className="gss-loader" id="create-event-placeholder">
        <img className="photos-date-img" src={loader} />
      </div>
    );
  } else if (photos.length === 0) {
    return (
      <div className="container text-center event-group-na">
        <div className="dv-event-no-albums">
          <div className="none-wrap">
            <img src={noimgs}></img>
            <p>{noPhotoMatchingText(filters)} </p>
          </div>
        </div>
      </div>
    );
  } else if (albumGrouping) {
    return (
      <div className="org-events-album-collection">
        <InfiniteScroll
          dataLength={photos.length}
          next={loadMorePhotos}
          hasMore={hasMorePhotos}
          scrollThreshold={0.7}
          loader={
            <div
              className="egm-loader gss-loader dv-section-footer loading"
              style={{ clear: "both" }}
            >
              <img className="photos-date-img" src={gssNewLoader} />
            </div>
          }
        >
          {uniqAlbums().map((album: Album, index: number) => (
            <div className="container" key={index}>
              <div className="org-events-single-album">
                <div className="event-group-heading">
                  <div className="org-events-event-title">
                    <a href={album.event.browsePhotosPath} target="_blank">
                      {album.event.name}
                    </a>
                  </div>
                  <b className="org-events-album-title">{album.name}</b>
                </div>

                {AlbumsGallery(albumPhotos(album.id), index + 1)}
              </div>
            </div>
          ))}
        </InfiniteScroll>
      </div>
    );
  } else
    return (
      <div className="container org-events-just-photos">{Gallery(photos)}</div>
    );
};

export default PhotoGallery;
